
import React from "react";
import sanitizeHtml from "sanitize-html";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Box,
    Typography,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Tab,
    Tabs,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Switch, FormControlLabel
} from "@mui/material";
import { Iconography, Button, Radio, ToggleSizes, Dropdown, Toggle, Loader, LoaderSizes, IconographySizes, IconographyThemes, InlineEditor } from "@hid-galaxy-ui/galaxy-react";
import IToolBarConfig from "@hid-galaxy-ui/galaxy-react/components/InlineEditor/IToolbarConfig";
import { AddEngagementDetailsType } from "../../../../../../redux/saga/partner-program/regional-multipliers/saga-actions";
import { getPartnerEngagementCategoryListSagaAction } from "../../../../../../redux/saga/partner-program/engagement-configuration/saga-actions";
import { useAppSelector, useAppDispatch } from "../../../../../../redux";
import "./AddEngagementModal.scss";
// import { AddPartnerRegionalMultiplierDetailsType } from "../../../../../../../redux/saga/partner-program/regional-multipliers/saga-actions";

type Option = { label: string; value: string };

type Props = {
    onClose: () => void;
    open?: boolean;
    mode?: "add" | "edit";
    engagementDetails: any;
    onSubmit: (payload: AddEngagementDetailsType) => void;
};

const fieldSx = {
    "& .MuiFilledInput-root": {
        backgroundColor: "#F7F7F7",
        borderRadius: "8px",
        border: "1px solid #E6E6E6",
        overflow: "hidden",
        "&:before, &:after": { display: "none" },
        minHeight: 36,
        "& .MuiInputBase-input": {
            padding: "8px 12px",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#222222",
            "&::placeholder": {
                color: "#9E9E9E",
                opacity: 1,
                fontSize: "10px",
            },
        },
        "&:hover": {
            backgroundColor: "#F7F7F7",
            borderColor: "#BDBDBD",
        },
        "&.Mui-focused": {
            borderColor: "#BDBDBD",
            boxShadow: "none",
            backgroundColor: "#F7F7F7",
        },
        "&.Mui-disabled": {
            backgroundColor: "#F5F5F5",
            borderColor: "#E0E0E0",
            "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#9E9E9E",
            },
        },
    },

    "& .MuiInputLabel-root": {
        color: "#737373",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "21px",
        letterSpacing: "0.2px",
        marginBottom: "4px",
        transform: "none",
        position: "relative",
    },
    "& .MuiInputLabel-shrink": {
        transform: "none",
    },

    "& .MuiFormHelperText-root": {
        marginTop: "6px",
        fontSize: "12px",
    },
};

const engagementInlineEditorToolBarConfig: IToolBarConfig = {
    headingConfig: {
        isDisplayHeading: true,
        headings: [false, 1, 2, 3, 4, 5, 6],
    },
    fontStyleConfig: {
        isDisplayBold: true,
        isDisplayItalic: true,
        isDisplayUnderline: true,
        isDisplayStrike: true,
    },
    indentConfig: {
        isDisplayOrdered: true,
        isDisplayBullet: true,
        isDisplayIndent: false,
    },
    colorConfig: {
        isDisplayBackground: false,
        isDisplayColor: false,
    },
    alignmentConfig: {
        isDisplayJustify: false,
        isDisplayCenter: false,
        isDisplayRight: false,
    },
    miscConfig: {
        isDisplayImage: false,
        isDisplayLink: false,
        isDisplayCodeblock: false,
        isDisplayBlockquote: false,
    },
    buttonConfig: {
        buttonLabel: "",
        displayPostButton: false,
        isRequired: false,
    },
};

const getPlainTextLength = (html: string = ""): number => {
    const plain = sanitizeHtml(html, {
        allowedTags: [],
        allowedAttributes: {},
    })
        .replace(/&nbsp;/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    return plain.length;
};

const TabPanel: React.FC<{ index: number; value: number; children: React.ReactNode }> = ({
    index,
    value,
    children,
}) => {

    if (value === index)
        return <Box sx={{ mt: 2 }}>{children}</Box>;
};

const AddEditEngagementModal: React.FC<Props> = ({
    onClose,
    open = true,
    mode = "add",
    engagementDetails,
    onSubmit,

}) => {

    const dispatch = useAppDispatch();


    const [form, setForm] = React.useState<AddEngagementDetailsType>(
        {
            activity_name: '',
            category_id: '',
            is_partner_editable: true,
            status: true,
            comments: '',
            description: '',
            accelerator_value: [{
                option_key: '',
                option_value: ''
            }]
        });
    const [ppTab, setPpTab] = React.useState<number>(0);

    const [selectedOption, setSelectedOption] = React.useState(null);

    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [errors, setErrors] = React.useState<Record<string, string>>({});
    const {
        partnerEngagementCategoryList,
        status: { partnerEngagementConfigurationListLoading,
            addPartnerEngagementConfigurationListStatus,
            addPartnerEngagementConfigurationListMessage,
            updatePartnerEngagementConfigurationListStatus,
            updatePartnerEngagementConfigurationListMessage,
            updatePartnerEngagementConfigurationListLoading
        } } = useAppSelector(
            (state) => state.partner_engagementConfiguration
        );

    const existingCategoryOptions = React.useMemo(
        () =>
            partnerEngagementCategoryList.map((category) => ({
                label: category.category_name,
                value: category.ID,
            })),
        [partnerEngagementCategoryList]
    );


    const dropdownOptions = React.useMemo(
        () => [
            {
                label: "New Category",
                value: "New Category",
                options: [
                    {
                        label: "Enter New Category",
                        value: "Enter New Category",
                    },
                ],
            },
            {
                label: "Existing Category",
                value: "Existing Category",
                options: [...existingCategoryOptions],
            },
        ],
        [existingCategoryOptions]
    );



    const onDropdownSelect = (data: { label: string; value: string } | null) => {
        setSelectedOption(data);

        if (data?.value === "Enter New Category") {
            setForm({
                ...form,
                category_id: ''
            });
        } else if (data?.value) {
            setForm({
                ...form,
                category_id: data.value
            });

            //   const selectedPartner = allPartners.find(
            //     (partner) => partner.partner_name === data.value
            //   );

            //   if (selectedPartner) {
            //     setFormData((prevData) => {
            //       const updatedData = { ...prevData };

            //       Object.keys(selectedPartner).forEach((key) => {
            //         let value = selectedPartner[key as keyof typeof selectedPartner];

            //         if (key === "partner_type" && typeof value === "string") {
            //           value = value.split(",").map((s) => s.trim());
            //         }
            //         if (key === "partner_potential" && typeof value === "string") {
            //           value = value.toLowerCase() === "prime" ? "No" : "Yes";
            //         }

            //         if (key in updatedData) {
            //           updatedData[key] = value;
            //         }
            //       });

            //       return updatedData;
            //     });
            //   }
        } else {
            setForm({
                ...form,
                category_id: ''
            });
            //handleChange(field.field_key, "");
        }
    };



    React.useEffect(() => {
        dispatch(getPartnerEngagementCategoryListSagaAction());

        if (!open) return;
        setForm({
            activity_name: engagementDetails.activity_name,
            category_id: engagementDetails.category_id,
            is_partner_editable: engagementDetails.is_partner_editable === 1 ? true : false,
            status: engagementDetails.status === 'Active' ? true : false,
            comments: engagementDetails.comments,
            description: engagementDetails.description,
            accelerator_value: engagementDetails.accelerator_value

        });

        if (mode === 'edit' && partnerEngagementCategoryList && engagementDetails.category_id &&
            partnerEngagementCategoryList.length
        ) {
            const existData = partnerEngagementCategoryList.find((data: any) => {
                return data.ID === engagementDetails.category_id
            })

            setSelectedOption({
                label: existData && existData.category_name ? existData.category_name : '',
                value: existData && existData.ID ? existData.ID : ''
            })

        }

        setErrors({});
    }, [open]);



    const validate = () => {
        const e: Record<string, string> = {};

        if (!form.activity_name.trim()) e.activity_name = "Activity label is required";

        // if (!form.category_id.trim()) {
        //     e.category_name = "Category is required";
        // }


        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        setSubmitted(true);

        const payload: AddEngagementDetailsType = {
            activity_name: form.activity_name ?? "",
            category_id: form.category_id ?? "",
            accelerator_value: form.accelerator_value ?? [],
            is_partner_editable: form.is_partner_editable ?? false,
            status: form.status ?? false,
            comments: form.comments ?? "",
            description: form.description ?? "",
        };



        onSubmit(payload);
    };
    const title = mode === "add" ? "Add New Engagement" : "Edit Engagement";
    const subtitle = "Configure a new engagement activity";
    const ctaLabel = mode === "add" ? "ADD ENGAGEMENT" : "SAVE CHANGES";


    const addRemoveAcceleratorValue = (type: string, index?: number) => {
        const deepClone = structuredClone(form);
        if (type === 'add') {
            deepClone.accelerator_value.push({
                option_key: '',
                option_value: ''
            });
            setForm({ ...deepClone })
        } else {
            deepClone.accelerator_value.splice(index, 1);

            setForm({ ...deepClone })
        }

    }

    const setDataInLevelFn = (value: any, key: string, index: number) => {
        const deepClone = structuredClone(form);
        key === 'option_value' ? deepClone.accelerator_value[index]['option_value'] = value :
            deepClone.accelerator_value[index]['option_key'] = value;

        setForm({ ...deepClone })
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            className="engagement-modal"
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    boxShadow: "0px 12px 24px rgba(0,0,0,0.12)",
                    overflow: "hidden",
                },
            }}>


            {(partnerEngagementConfigurationListLoading ||
                !submitted) &&
                <DialogTitle
                    className="dialog-title"
                >
                    <Box sx={{

                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                    }}>
                        <Box>
                            <Typography
                                className="title-text"
                            >
                                {title}
                            </Typography>
                            <Typography
                                className="subtitle-text"
                            >
                                {subtitle}
                            </Typography>
                        </Box>

                        <IconButton aria-label="Close" onClick={onClose}>
                            <Iconography icon="xmark" />
                        </IconButton>
                    </Box>
                </DialogTitle>
            }


            {submitted ? (
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                    }}
                    style={{ padding: "24px" }}
                >
                    {(partnerEngagementConfigurationListLoading || updatePartnerEngagementConfigurationListLoading) && (
                        <Loader variant={LoaderSizes.medium} />
                    )}
                    {(mode === "add" || mode === 'edit') && !partnerEngagementConfigurationListLoading && (
                        <>
                            <Iconography
                                icon={addPartnerEngagementConfigurationListStatus ? "circleCheck" : "circleXmark"}
                                size={IconographySizes.XLarge}
                                theme={
                                    addPartnerEngagementConfigurationListStatus
                                        ? IconographyThemes.Success
                                        : IconographyThemes.Error
                                }
                            />
                            <Typography variant="body2">
                                {addPartnerEngagementConfigurationListMessage ||
                                    (addPartnerEngagementConfigurationListStatus
                                        ? "Engagement added successfully"
                                        : "Failed to engagement")}
                            </Typography>
                            <Button
                                label="Close"
                                onClick={onClose}
                                variant="primary"
                            />
                        </>
                    )}
                </DialogContent>
            ) :

                <>
                    <DialogContent
                        className="dialog-content"
                    >


                        <Tabs
                            value={ppTab}
                            onChange={(_, v) => setPpTab(v)}
                            aria-label="Add Engagement"
                            className="pp-config-tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Activity Levels" />
                            <Tab label="Description and Comment" />
                        </Tabs>
                        <TabPanel index={0} value={ppTab}>

                            <Box
                                className="form-row">
                                <FormControl fullWidth variant="filled" sx={fieldSx}>
                                    <InputLabel id="region-name-label">Activity Label</InputLabel>
                                    <TextField
                                        id="Activity Label"
                                        name="Activity Label"
                                        placeholder="e.g., Leads In"
                                        value={form.activity_name}
                                        required
                                        onChange={(e) => {
                                            setForm({
                                                ...form,
                                                activity_name: e.target.value
                                            })
                                        }}
                                        error={!!errors.activity_name}
                                        helperText={errors.activity_name || ""}
                                    />

                                </FormControl>
                                <FormControl
                                    id="partnerName"
                                    fullWidth variant="filled" sx={fieldSx}>
                                    <InputLabel id="region-code-label">Category</InputLabel>

                                    <Dropdown
                                        id="partnerName"
                                        placeholder="Category"
                                        theme="dark"
                                        options={dropdownOptions}
                                        selected={selectedOption}
                                        isSearchable={true}
                                        isRequired={true}
                                        className=

                                        "hid-galacontrol"

                                        onSelect={(data) => {
                                            onDropdownSelect(data);
                                        }}
                                    />

                                </FormControl>
                            </Box>

                            {selectedOption?.value === "Enter New Category" && (

                                <Box className="form-field-full">
                                    <FormControl fullWidth variant="filled" sx={fieldSx}>
                                        <InputLabel id="region-code-label">Enter New Category Name</InputLabel>
                                        <TextField
                                            id="Levels"
                                            placeholder="Enter New Category Name"
                                            value={form.category_id}
                                            onChange={(e) => {
                                                setForm({
                                                    ...form,
                                                    category_id: e.target.value
                                                })
                                                //setDataInLevelFn(e.target.value, 'levels')
                                            }}

                                        />
                                    </FormControl>

                                </Box>

                            )}


                            <Box className="levels-header">
                                <Typography className="levels-label">
                                    Levels and Accelerator Values
                                </Typography>
                                <Button
                                    variant="secondary"
                                    label="ADD"
                                    icon={<Iconography icon="plus" />}
                                    onClick={() => {
                                        addRemoveAcceleratorValue('add')
                                    }}
                                />
                            </Box>


                            <Paper variant="outlined" className="accelerator-table">
                                <Table size="small" aria-label="accelerator table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="pd15">Levels</TableCell>
                                            <TableCell className="pd15">Accelerator Value</TableCell>
                                            <TableCell className="pd15">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>


                                        {
                                            form.accelerator_value &&
                                                form.accelerator_value.length ?
                                                form.accelerator_value
                                                    .map((r, idx) => (
                                                        <TableRow key={`a-${idx}`}>
                                                            <TableCell>


                                                                <TextField
                                                                    id="Levels"
                                                                    name="Levels"
                                                                    className="fullWidth"
                                                                    value={r.option_key}
                                                                    onChange={(e) => {
                                                                        setDataInLevelFn(e.target.value, 'option_key', idx)
                                                                    }}

                                                                />

                                                            </TableCell>
                                                            <TableCell>

                                                                <TextField
                                                                    type="number"
                                                                    id="Accelerator Values"
                                                                    name="Accelerator Values"
                                                                    className="fullWidth"
                                                                    value={r.option_value}
                                                                    onChange={(e) => {
                                                                        setDataInLevelFn(e.target.value, 'option_value', idx)
                                                                    }}
                                                                />

                                                            </TableCell>
                                                            <TableCell className="tcenter">
                                                                <IconButton
                                                                    onClick={() => {
                                                                        addRemoveAcceleratorValue('remove', idx)
                                                                    }}
                                                                    aria-label={`Delete`} >
                                                                    <Iconography icon="trashCan" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                :
                                                <TableRow >
                                                    <TableCell colSpan={3}>
                                                        <Typography
                                                            className="no-data-message"

                                                        >
                                                            No data Available for display.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>

                                        }
                                    </TableBody>
                                </Table>
                            </Paper>


                            <Box
                                className="toggle-row">

                                <FormControl fullWidth variant="filled" sx={fieldSx}>


                                    <Toggle
                                        labelText="Partner Edit Access"
                                        labelOFF="Editable"
                                        labelON="Editable"
                                        //id={"toggle-" + user.ID}
                                        onClick={() => setForm({
                                            ...form,
                                            is_partner_editable: !form.is_partner_editable
                                        })}
                                        toggled={form.is_partner_editable}
                                        size={ToggleSizes.Mini}
                                    //disabled={disabled}
                                    />
                                    {/* <InputLabel id="region-name-label">Partner Edit Access</InputLabel>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.is_partner_editable}
                                        onChange={() => setForm({
                                            ...form,
                                            is_partner_editable: !form.is_partner_editable
                                        })}
                                        color="success" // green color
                                    />
                                }
                                label="Editable"
                            /> */}

                                </FormControl>



                                <FormControl fullWidth variant="filled" sx={fieldSx}>
                                    {/* <InputLabel id="region-name-label">Engagement Status</InputLabel> */}

                                    <Toggle
                                        labelText="Engagement Status"
                                        labelOFF="Active"
                                        labelON="Active"
                                        //id={"toggle-" + user.ID}
                                        onClick={() => setForm({
                                            ...form,
                                            status: !form.status
                                        })}
                                        toggled={form.status}
                                        size={ToggleSizes.Mini}
                                    //disabled={disabled}
                                    />



                                </FormControl>

                            </Box>






                        </TabPanel>
                        <TabPanel index={1} value={ppTab}>
                            <Box>
                                <Box className="field-label-row">
                                    <label>Description</label>
                                    <span className="char-count">
                                        {getPlainTextLength(form.description || "")}/1000
                                    </span>
                                </Box>
                                <Box className="engagement-inline-editor-wrap">
                                    <InlineEditor
                                        id="engagement-description"
                                        placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
                                        toolBarConfig={engagementInlineEditorToolBarConfig}
                                        editorData={form.description}
                                        handleOnChange={(value: string) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                description: value,
                                            }))
                                        }
                                    />
                                </Box>
                                {errors.description && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5, mb: 2 }}
                                    >
                                        {errors.description}
                                    </Typography>
                                )}

                                <Box className="field-label-row" sx={{ mt: 2 }}>
                                    <label>Comment</label>
                                    <span className="char-count">
                                        {getPlainTextLength(form.comments || "")}/500
                                    </span>
                                </Box>
                                <Box className="engagement-inline-editor-wrap">
                                    <InlineEditor
                                        id="engagement-comment"
                                        placeholder="Optional comment..."
                                        toolBarConfig={engagementInlineEditorToolBarConfig}
                                        editorData={form.comments}
                                        handleOnChange={(value: string) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                comments: value,
                                            }))
                                        }
                                    />
                                </Box>
                                {errors.comments && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.comments}
                                    </Typography>
                                )}
                            </Box>
                        </TabPanel>


                    </DialogContent>
                    <DialogActions className="dialog-actions">
                        <Button
                            variant="secondary"
                            label="Cancel"
                            onClick={onClose}
                        // disabled={busy}
                        />
                        <Button
                            variant="primary"
                            label={ctaLabel}
                            onClick={handleSubmit}
                        //disabled={busy}
                        // loading={busy}
                        />
                    </DialogActions>
                </>
            }


        </Dialog>
    );
};

export default AddEditEngagementModal;


